var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs-wrapper"},[_c('el-tabs',{model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"产品","name":"product"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }